import React from 'react';

import * as styles from './ButtonUp.module.scss';

export const ButtonUp: React.FC = () => {
	const scrollTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	return (
		<button
			onClick={scrollTop}
			className={styles.btnUp}
			aria-label="Button scrolling to top"
		></button>
	);
};
